(() => {
  if (window.__bitcoTabbarBound) return;
  window.__bitcoTabbarBound = true;

  // Keeps the mobile bottom bar's cart bubble (snippets/bitco-tabbar.liquid) in step with the
  // header's.
  //
  // Why mirror instead of rendering a second bubble: Dawn's Section Rendering API is what repaints
  // the count after every AJAX cart change, and all three callers (assets/cart.js,
  // assets/cart-drawer.js, assets/cart-notification.js) hardcode a getSectionsToRender() entry
  // that assigns sections/cart-icon-bubble.liquid's output to the element with id
  // `cart-icon-bubble` — a single id, so there is no supported way to have it paint a second
  // target. Mirroring the header bubble keeps it the single source of truth and leaves Dawn's
  // cart JS untouched.
  const getSource = () => document.querySelector('#cart-icon-bubble .bitco-header__count');
  const getDest = () => document.querySelector('[data-bitco-tabbar-count]');

  const sync = () => {
    const source = getSource();
    const dest = getDest();
    if (!source || !dest) return;
    dest.textContent = source.textContent.trim();
    dest.classList.toggle('is-empty', source.classList.contains('is-empty'));
  };

  // Re-created on every init so a stale observer never keeps watching a detached #cart-icon-bubble
  // after the theme editor swaps the header section's DOM.
  let observer = null;

  const init = () => {
    if (observer) observer.disconnect();
    observer = null;

    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !getDest()) return;

    sync();
    // childList catches the innerHTML replacement, characterData the count text itself.
    observer = new MutationObserver(sync);
    observer.observe(bubble, { childList: true, subtree: true, characterData: true });
  };

  const bindSectionReloadListenerOnce = () => {
    if (window.__bitcoTabbarSectionListenerBound) return;
    window.__bitcoTabbarSectionListenerBound = true;
    document.addEventListener('shopify:section:load', init);
  };

  const start = () => {
    bindSectionReloadListenerOnce();
    init();
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
